<template>
    <v-sheet v-if="$store.getters.is_loggedin" style="">
        <v-app-bar app elevate-on-scroll style="background-color:#fff;border-bottom:1px solid #ccc; " dense elevation="0">
            <v-toolbar-title class="text-uppercase">
                <span>CRIADORES</span>
                <span class="font-weight-light">| Nova Música Gospel</span>
            </v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-spacer></v-spacer>
            <!--slot name="topbar_external"></slot-->
            <template v-if="$vuetify.breakpoint.smAndUp">
                <div>
                    <b>Olá</b>
                    {{$store.getters.user.myself.name}}
                </div>
            </template>
        &nbsp;&nbsp;
            <v-app-bar-nav-icon small @click="drawer = !drawer"></v-app-bar-nav-icon>
            &nbsp;&nbsp;
            <!--v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
            </v-btn-->
        </v-app-bar>

        <!-- Menu lateral -->

        <v-navigation-drawer v-model="drawer" fixed temporary right>
            <v-list-item dense> 
                <!--v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
                </v-list-item-avatar-->

                <v-list-item-content>
                    <v-list-item-title>Você tem R$ {{formated_money}}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action> <v-btn small icon @click="drawer=!drawer" > <v-icon>close</v-icon></v-btn> </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item v-for="item in items" :key="item.title" :to="{name:item.link}">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!--v-list-item @click="ajuda_video()">
                    <v-list-item-icon>
                        <v-icon>ondemand_video</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>AJUDA EM VIDEO</v-list-item-title>
                    </v-list-item-content>
                </v-list-item-->
            </v-list>
            <template v-slot:append>
                <v-list dense>
                     <v-list-item
                        href="https://www.novamusicagospel.com.br/Contrato_Nova_Música_Gospel.pdf"
                        target="_blank"
                    >
                        <v-list-item-icon>
                            <v-icon>assignment</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Contrato</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        href="https://www.novamusicagospel.com.br/termos-de-uso.html"
                        target="_blank"
                    >
                        <v-list-item-icon>
                            <v-icon>assignment</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Termos de Uso</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        href="https://www.novamusicagospel.com.br/politica-de-privacidade.html"
                        target="_blank"
                    >
                        <v-list-item-icon>
                            <v-icon>policy</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Política de Privacidade</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <div class="pa-2">
                        <v-btn
                            block
                            text
                            @click="$store.commit('token',null); $router.push({name:'login'})"
                        >
                            <!--v-icon>directions_run</v-icon-->
                            SAIR
                        </v-btn>
                    </div>
                </v-list>
            </template>
        </v-navigation-drawer>
    </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import { money } from "../../app/general";

let m_money = new money();
export default {
    props: {
        money_disabled: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        drawer: null,       
        items: [
            { title: "Saldo atual", icon: "show_chart", link: "reports" },
            { title: "Recibos", icon: "receipt", link: "invoices" },            
            { title: "Pedidos", icon: "list", link: "orders" },
            { title: "Meus dados", icon: "people", link: "settings" },
        ]
    }),
    computed: {
        ...mapGetters(["current_credit"]),
        formated_money() {
            return m_money.format(this.current_credit);
        },
      
    },
    methods: {
        ajuda_video() {
            this.$emit("open_wizard");
        }
    }
};
</script>
